module.exports = __webpack_public_path__ + "media/images/ohap_graded quiz-a51514eb8a4d15be4256f2034eb36a27.png";